import { creditCardSettings } from './CreditCard/settings';
import { watermarkSettings } from './CreditCard/components/Watermark/settings';
import { bankAccountSettings } from './BankAccount/settings';
import { tableSettings } from './Table/settings';

const organismsSettings = {
  CreditCard: creditCardSettings,
  Watermark: watermarkSettings,
  BankAccount: bankAccountSettings,
  Table: tableSettings,
};

export default organismsSettings;
